import { render, staticRenderFns } from "./EditMaterial.vue?vue&type=template&id=25ce5f54&"
import script from "./EditMaterial.vue?vue&type=script&lang=js&"
export * from "./EditMaterial.vue?vue&type=script&lang=js&"
import style0 from "./EditMaterial.vue?vue&type=style&index=0&id=25ce5f54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports